angular.module('directives.dashboard').directive('wgtCalHeatmap', ['DashboardApiService', '$compile',
  function(DashboardApiService, $compile) {
    return {
      templateUrl: 'directives/dashboard/widgets/wgtCalHeatmap/wgtCalHeatmap.tpl.html',
      link: function($scope, $element) {

        $scope.elId = 'chart-' + Math.floor((Math.random() * 6000) + 1);
        $element.find('.heatmap-container')
          .append($compile("<div class='svg-container' id='" + $scope.elId + "'></div>")($scope));

        $scope.isLoaded = false;
        $scope.hasError = false;
        $scope.loadWidget = function() {
          DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
            .then(function(response) {

              if (response.data === '') {
                //No data, leaving
                return;
              }

              $scope.widgetData = response.data;
              $scope.isLoaded = true;

              var margin = {
                  top: 50,
                  right: 0,
                  bottom: 100,
                  left: 50
                },
                width = 960 - margin.left - margin.right,
                height = 430 - margin.top - margin.bottom,
                gridSize = Math.floor(width / 24),
                legendElementWidth = gridSize * 2,
                buckets = 9,
                colors = ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
                days = ["må", "ti", "on", "to", "fr", "lö", "sö"],
                times = ["07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"];
              var timeHacked = 6;
              draw($scope.widgetData);

              function draw(data) {

                var colorScale = d3.scale.quantile()
                  .domain([0, buckets - 1, d3.max(data, function(d) {
                    return d.value;
                  })])
                  .range(colors);
                $("#" + $scope.elId).empty();
                var svg = d3.select("#" + $scope.elId).append("svg")
                  .attr("width", "100%")
                  .attr("height", "100%")
                  .attr("viewBox", "0 0 800 600")
                  .attr("preserveAspectRatio", "xMinYMin meet")
                  .attr("class", "svg-content")
                  .append("g")
                  .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

                var dayLabels = svg.selectAll(".dayLabel")
                  .data(days)
                  .enter().append("text")
                  .text(function(d) {
                    return d;
                  })
                  .attr("x", 0)
                  .attr("y", function(d, i) {
                    return i * gridSize;
                  })
                  .style("text-anchor", "end")
                  .attr("transform", "translate(-6," + gridSize / 1.5 + ")")
                  .attr("class", function(d, i) {
                    return ((i >= 0 && i <= 4) ? "dayLabel mono axis axis-workweek" : "dayLabel mono axis");
                  });

                var timeLabels = svg.selectAll(".timeLabel")
                  .data(times)
                  .enter().append("text")
                  .text(function(d) {
                    return d;
                  })
                  .attr("x", function(d, i) {
                    return i * gridSize;
                  })
                  .attr("y", 0)
                  .style("text-anchor", "middle")
                  .attr("transform", "translate(" + gridSize / 2 + ", -6)")
                  .attr("class", function(d, i) {
                    return ((i >= 7 && i <= 16) ? "timeLabel mono axis axis-worktime" : "timeLabel mono axis");
                  });

                var heatMap = svg.selectAll(".hour")
                  .data(data)
                  .enter().append("rect")
                  .attr("x", function(d) {
                    return (d.hour - 1 - timeHacked) * gridSize;
                  })
                  .attr("y", function(d) {
                    return (d.day - 1) * gridSize;
                  })
                  .attr("rx", 4)
                  .attr("ry", 4)
                  .attr("class", "hour bordered")
                  .attr("width", gridSize)
                  .attr("height", gridSize)
                  .style("fill", colors[0]);

                heatMap.transition().duration(1000)
                  .style("fill", function(d) {
                    return colorScale(d.value);
                  });

                heatMap.append("title").text(function(d) {
                  return d.value;
                });

                var legend = svg.selectAll(".legend")
                  .data([0].concat(colorScale.quantiles()), function(d) {
                    return d;
                  })
                  .enter().append("g")
                  .attr("class", "legend");

                legend.append("rect")
                  .attr("x", function(d, i) {
                    return legendElementWidth * i;
                  })
                  .attr("y", height)
                  .attr("width", legendElementWidth)
                  .attr("height", gridSize / 2)
                  .style("fill", function(d, i) {
                    return colors[i];
                  });

                legend.append("text")
                  .attr("class", "mono")
                  .text(function(d) {
                    return "≥ " + Math.round(d);
                  })
                  .attr("x", function(d, i) {
                    return legendElementWidth * i;
                  })
                  .attr("y", height + gridSize);
              }

            }, function(response) {
              $scope.hasError = true;
            });
        };
        $scope.loadWidget();

      }
    };
  }
]);
